import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.OWNERS;
const _ = (...arg: any[]) => "/" + BASE + "/" + arg.join("/");

// create path router
const ROUTER = {
  ROOT: "",
  DETAIL: "detail",
  COMMON_DETAIL: "common-detail",
  EDIT: "edit"
};

// create path routes
const PATH = {
  ROOT: `/${BASE}`,
  DETAIL: (ID: number) => _(ROUTER.DETAIL, ID),
  EDIT: (ID: number) => _(ROUTER.EDIT, ID),
  COMMON_DETAIL: (OWNER_ID: number, AGENT_ID: number) =>
    _(ROUTER.COMMON_DETAIL, OWNER_ID, AGENT_ID)
};

// export
const OWNER_PATH = {
  ROUTES: PATH,
  ROUTER
};

export default OWNER_PATH;
